/* @author: Augusto Monteiro */

Greenmile.Panel = Greenmile.Panel || {};

Greenmile.Panel.Header = function (id) {

    this.headerContainer = document.createElement("div");
    this.headerContainer.className = "PanelHeader";
    this.quickColorsFilter = new Monet.UI.QuickColorsFilter();
    this.quickFilter = new Monet.UI.QuickFilter();
    this.processingEl = document.createElement("div");
    this.panel = App.Panels[id];

    this.setPanelId = function (id) {
        this.panel = App.Panels[id];
    };

    this.getRule = function () {
        var criteria            = {}
            , quickColorsFilter = this.quickColorsFilter.getColors()[0];

        if (quickColorsFilter) {
            var panelRule = this.panel.panel.panelRules.filter(function (rule) {
                return rule.cardColor === quickColorsFilter;
            })[0];
            criteria.panelRule = {
                id: panelRule.id
            };
        }
        return criteria;
    };

    this.getFilterWithPagination = function () {
        var data = this.getRule();
        data.monetCriteria = this.quickFilter.getCriteria();
        data.firstResult = this.panel.firstResult;
        data.maxResults = this.panel.maxResults;

        return data;

    };

    this.executeFilter = function () {
        this.panel.cardList.executeFilter();
    }.bind(this);

    this.getPanelColors = function () {

        return this.panel.panel.panelRules.map(function (condition) {
            return {
                color: condition.cardColor,
                title: condition.ruleName,
                total: this.panel.totals.filter(function (rule) {
                    return condition.id === (rule.panelRule ? rule.panelRule.id : false);
                })[0].numberOfRoutes
            };
        }.bind(this));

    };

    this.renderColors = function () {

        this.quickColorsFilter.setActionListener(this.executeFilter);

        this.quickColorsFilter.showPercents = this.panel.panel.showPercentage;

        this.quickColorsFilter.render("cards", this.getPanelColors());

        return this.quickColorsFilter.rootEl;

    };

    this.updateTotals = function () {
        this.quickColorsFilter.updateCounts(this.getPanelColors());
    };

    this.renderFilter = function () {

        var frontField = this.panel.panel.panelCardFields.filter(function (field) {
            return field.isFront === true;
        });

        this.quickFilter.filters["INPUT"].attr = frontField[0].attribute;

        this.quickFilter.setFiltersConfig(["ROUTE_NOT_STARTED", "ROUTE_STARTED", "ROUTE_DEPARTED_ORIGIN", "ROUTE_ARRIVED_ORIGIN", "INPUT"]);

        this.quickFilter.setActionListener(this.executeFilter);

        this.quickFilter.render();

        return this.quickFilter.rootEl;

    };

    this.render = function () {
        this.headerContainer.appendChild(this.renderFilter());
        this.headerContainer.appendChild(this.renderColors());
    };

};
